import { Container, Eyebrow } from "./UI";

export default function PageIntro({ eyebrow, title, children }) {
  return (
    <section className="sn-border-b sn-border-line sn-py-12 md:sn-py-16">
      <Container className={`sn-grid sn-gap-6 ${children ? "lg:sn-grid-cols-[1.2fr_1fr] lg:sn-items-end lg:sn-gap-16" : ""}`}>
        <div>
          <Eyebrow>{eyebrow}</Eyebrow>
          <h1 className="sn-font-display sn-text-4xl sn-leading-tight sn-tracking-[-0.04em] sn-text-forest md:sn-text-5xl">{title}</h1>
        </div>
        {children && <p className="sn-max-w-xl sn-text-base sn-leading-relaxed sn-text-muted md:sn-text-lg">{children}</p>}
      </Container>
    </section>
  );
}
